import { Button, Form, Select } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import styles from "../styles/Content.module.css";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const data = [
    {
      name: 'Page A',
      actual: 4000,
      anterior: 2400,
      amt: 2400,
    },
    {
      name: 'Page B',
      actual: 3000,
      anterior: 1398,
      amt: 2210,
    },
    {
      name: 'Page C',
      actual: 2000,
      anterior: 9800,
      amt: 2290,
    },
    {
      name: 'Page D',
      actual: 2780,
      anterior: 3908,
      amt: 2000,
    },
    {
      name: 'Page E',
      actual: 1890,
      anterior: 4800,
      amt: 2181,
    },
    {
      name: 'Page F',
      actual: 2390,
      anterior: 3800,
      amt: 2500,
    },
    {
      name: 'Page G',
      actual: 3490,
      anterior: 4300,
      amt: 2100,
    },
  ];

const OrdersSales = ({branches, isAdmin, summaryOrders}) => {
  return (
    <div className={styles.cardContent}>
      {isAdmin && (
        <div className={styles.filterForm}>
          <Form layout="inline">
            <Form.Item>
              <Select
                className={styles.select}
                showSearch
                optionFilterProp="label"
                options={branches.map((item) => {
                  return { value: item.id, label: item.zone };
                })}
                placeholder="Todas las sucursales"
                mode="multiple"
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" icon={<FilterOutlined />} style={{ display: 'inline-flex', alignItems: 'center' }}>Buscar</Button>
            </Form.Item>
          </Form>
        </div>
      )}

      <div className={styles.chartContainer}>
        <p className={styles.chartTitle}>Pedidos y Ventas Totales</p>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="name" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip
              contentStyle={{ borderRadius: '8px', border: '1px solid #f0f0f0', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="anterior"
              stroke="#bbb"
              strokeDasharray="5 5"
              strokeWidth={2}
              dot={{ r: 3, fill: '#bbb' }}
              activeDot={{ r: 5 }}
            />
            <Line
              type="monotone"
              dataKey="actual"
              stroke="#FF671D"
              strokeWidth={2}
              dot={{ r: 3, fill: '#FF671D' }}
              activeDot={{ r: 6, stroke: '#FF671D', strokeWidth: 2, fill: '#fff' }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default OrdersSales;
